<template>

<div>

  <div id="app" class="min-h-screen">
    <TitleBar :key="$route.fullPath" />
    <router-view></router-view>
  </div>

<Footer />
  </div>
</template>

<script>
import TitleBar from './components/TitleBar.vue'
import Footer from './components/Footer.vue'

// ui.start('#firebaseui-auth-container', {
//   signInOptions: [
//     // List of OAuth providers supported.
//     firebase.auth.GoogleAuthProvider.PROVIDER_ID,
//   ],
//   // Other config options...
// });



export default {
  name: 'App',
  components: {
    TitleBar,
    Footer
  },
}
</script>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;

/* .firebaseui-idp-icon {
  display: inline;
  max-width: 50px;
  padding: 0.5rem;
}



.firebaseui-idp-text-short {
  display: none
} */

.firebaseui-idp-button {
  background: #1F2933 !important;
}

@import url(./assets/styles/paymentfont.min.css);

@font-face {
    font-family: Valorant;
    font-weight: 400;
    src: url(./assets/fonts/Valorant.ttf) format("woff");
  }

body {
    background: #0F1923;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue